import { fetchAllUsers } from '@/api/user';
import types from '../types';

const state = {
  allUsers: [],
  users: []
};

const mutations = {
  [types.SET_ALLUSERS](state, allUsers) {
    state.allUsers = allUsers || [];
  },
  [types.SET_USERS](state, users) {
    state.users = users || [];
  },
};

const actions = {
  fetchAllUsers({ commit }) {
    this.tableLoading = true;
    return fetchAllUsers()
      .then(res => {
        const allUsers = (res.data.data || []).map(user => {
          return { ...user, disabled: user.status !== 'enable' };
        });
        const users = allUsers.filter(e => e.status != 'delete');
        commit(types.SET_ALLUSERS, allUsers);
        commit(types.SET_USERS, users);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js